import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { Campaign } from "../../models/campaign.model";
import { PermissionCheck } from "../../shared/permission";
import { DialogUtils } from "../../helper/dialog.helper";
import { DefaultDialogs } from "../../helper/default-dialogs.helper";
import { NavigationBarHelperService } from "./navigation-bar.helper";
import { ScreenUtils } from "../../helper/screen.helper";
import { Organisation } from "../../models/organisation.model";
import { WhiteLabelDataProvider } from "../../data-provider/white-label.dp";
import { User } from "../../models/user.model";
import { UserDataProvider } from "../../data-provider/user.dp";

let LeaderSideNavBarComponent = {
    selector: "vcLeaderSideNav",
    templateUrl: "/angular/components/navigation/leader-sidenav.component.html",
    bindings: {
        setSelectedOrganisation: "&",
        changeLiveCampaign: "&",
        openProfileMenu: "&",
        profileMenuOpen: "=",
        selectedOrganisation: "=",
        switchLeaderView: "&",
    },
    controller: class LeaderSideNavBarController {
        // * bindings for typescript compiler *
        public setSelectedOrganisation: any;
        public changeLiveCampaign: any;
        public selectedOrganisation: any;
        public switchLeaderView: any;
        // ************************************

        public navigationBarService: NavigationBarHelperService;
        public readonly permissionProvider: PermissionCheck;
        public readonly __env: any;

        public campaignDataProvider: CampaignDataProvider;
        public activeCampaign: Campaign;
        public readonly isLeaderView: boolean;
        private readonly dialog: DialogUtils;
        private readonly defaultDialogs: DefaultDialogs;
        private readonly $scope: any;

        public hover: boolean = false;
        public screen: any;
        public pages: any;
        public pinned: string[] = [];
        public whiteLabelDataProvider: WhiteLabelDataProvider;
        public activeOrganisation: Organisation;

        public importPageText: string;
        public importPageUrl: string;

        public signedInUser: User;

        constructor(
            $scope: any,
            ScreenUtils: ScreenUtils,
            DialogUtils: DialogUtils,
            DefaultDialogs: DefaultDialogs,
            __app_type: string,
            CampaignDataProvider: CampaignDataProvider,
            WhiteLabelDataProvider: WhiteLabelDataProvider,
            UserDataProvider: UserDataProvider,
            NavigationBarHelperService: NavigationBarHelperService,
            PermissionCheck: PermissionCheck,
            __env: any
        ) {
            this.dialog = DialogUtils;
            this.screen = ScreenUtils;
            this.whiteLabelDataProvider = WhiteLabelDataProvider;
            this.$scope = $scope;
            this.campaignDataProvider = CampaignDataProvider;
            this.navigationBarService = NavigationBarHelperService;
            this.permissionProvider = PermissionCheck;
            this.isLeaderView = __app_type == "LEADER";
            this.defaultDialogs = DefaultDialogs;
            this.__env = __env;
            this.activeCampaign = this.campaignDataProvider.getActiveCampaign();
            this.activeCampaign.getLocalStorage();

            this.campaignDataProvider
                .getOrganisations()
                .then((organisation: Organisation) => {
                    this.activeOrganisation = organisation;
                });

            if (this.activeCampaign.localInfo.sidenav) {
                if (this.activeCampaign.localInfo.sidenav.leader_pinned) {
                    this.pinned =
                        this.activeCampaign.localInfo.sidenav.leader_pinned;
                } else {
                    this.activeCampaign.localInfo.sidenav.leader_pinned = [];
                }

                if (this.activeCampaign.localInfo.sidenav.mini) {
                    this.navigationBarService.mini_side_nav =
                        this.activeCampaign.localInfo.sidenav.mini;
                } else {
                    this.activeCampaign.localInfo.sidenav.mini = false;
                }
            } else {
                this.activeCampaign.localInfo.sidenav = {
                    mini: false,
                    pinned: [],
                    leader_pinned: [],
                };
            }
            this.navigationBarService.mini_side_nav =
                this.activeCampaign.localInfo.sidenav.mini;

            this.activeCampaign.saveLocalStorage();
            this.navigationBarService.setPages(this.permissionProvider);

            this.campaignDataProvider
                .getOrganisations()
                .then((organisation: Organisation) => {
                    this.permissionProvider.setPermission(
                        this.activeOrganisation.permissionid
                    );
                    this.permissionProvider
                        .getFeaturePermissions()
                        .then((featurePermission) => {
                            if (
                                this.permissionProvider.hasPermission(
                                    "IMPORT_ORGANISATION_LEVEL"
                                )
                            ) {
                                this.importPageText = "Imports & Exports";
                                this.importPageUrl = "#/leader_voterfiles";
                            } else {
                                this.importPageText = "Exports";
                                this.importPageUrl = "#/leader_exports";
                            }
                        });
                });

            this.signedInUser = UserDataProvider.getActiveUser();
        }

        getPinnedPages(page: string) {
            let pages = [];

            angular.forEach(
                this.navigationBarService.leaderPages,
                (category) => {
                    angular.forEach(category.pages, (page) => {
                        if (this.pinned && this.pinned.includes(page.key)) {
                            pages.push(page);
                        }
                    });
                }
            );

            return pages;
        }

        isPinnedPage(page: string): boolean {
            if (this.pinned && this.pinned.length) {
                return this.pinned.includes(page);
            }
            return false;
        }

        getPageTarget(page: string): string {
            if (page == "support" || page == "refer") {
                return "_blank";
            }
            return "_self";
        }

        openInviteDialog(activeOrganisation: Organisation, ev: any): void {
            this.dialog.show({
                component: "vc-leader-invite",
                targetEvent: ev,
                scope: this.$scope,
                locals: {
                    organisation: activeOrganisation,
                },
                size: "large",
            });
        }

        sideNavHover(page: string) {
            setTimeout(
                () => (this.navigationBarService.mini_side_nav = false),
                100
            );
        }

        sideNavStopHover(page: string) {
            this.navigationBarService.mini_side_nav = true;
        }

        pinPage(page: string) {
            let idx: number = this.pinned.findIndex(
                (element) => element == page
            );

            if (idx > -1) {
                this.pinned.splice(idx, 1);
            } else {
                this.pinned.push(page);
            }

            this.activeCampaign.localInfo.sidenav.leader_pinned = this.pinned;
            this.activeCampaign.saveLocalStorage();
        }

        toggleMiniSideNav(): void {
            this.navigationBarService.mini_side_nav =
                !this.navigationBarService.mini_side_nav;
            this.activeCampaign.getLocalStorage();
            this.activeCampaign.localInfo.sidenav.mini =
                this.navigationBarService.mini_side_nav;
            this.activeCampaign.saveLocalStorage();
        }

        changeCampaign(campaign: Campaign, redirect?: string): void {
            this.changeLiveCampaign({ campaign: campaign, redirect: redirect });
        }

        setSelectedOrg(organisation: Organisation): void {
            this.setSelectedOrganisation({ organisation: organisation });
        }

        switchToLeader(organisation: Organisation): void {
            this.switchLeaderView({ organisation: organisation });
        }
    },
};

angular
    .module("navigation")
    .component(LeaderSideNavBarComponent.selector, LeaderSideNavBarComponent);
